import { AuthState } from '../../models/AuthState';
import {
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_FAILED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  AUTH_REQUEST_START,
  AUTH_REQUEST_END,
  LOG_OUT,
  LOG_OUT_SUCCESS,
  MLOBBY_SHOW,
} from './authActionTypes';

type Action = {
  type: string;
  payload: any;
};

const initialState: AuthState = {
  balanceSummary: {
    balance: null,
    balanceId: 0,
    currenciesAllowed: 0,
    currency: '',
    exposure: null,
    exposureLimit: 0,
    maxStakeSB: 0,
    minStakeSB: 0,
    preferredCurrency: '',
    username: '',
  },
  jwtToken: sessionStorage.getItem('jwt_token') || '',
  loading: false,
  loginError: '',
  loggedIn: sessionStorage.getItem('jwt_token') ? true : false,
  isMolobby: sessionStorage.getItem('mlobby') ? true : false,
};

const authReducer = (state = initialState, action: Action): AuthState => {
  switch (action.type) {
    case AUTH_REQUEST_START:
      return {
        ...state,
        loading: true,
        loginError: '',
      };
    case AUTH_REQUEST_END:
      return {
        ...state,
        loading: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        jwtToken: action.payload,
        loading: false,
        loginError: '',
        loggedIn: true,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        jwtToken: '',
        loading: false,
        loginError: action.payload,
        loggedIn: false,
      };
    case LOG_OUT:
      return {
        ...state,
        loggedIn: false,
        jwtToken: '',
        loading: false,
      };
    case LOG_OUT_SUCCESS:
      return {
        ...state,
        loggedIn: false,
        jwtToken: null,
        loading: false,
      };

    case FETCH_BALANCE_SUCCESS:
      const balanceSummary = action.payload;
      balanceSummary.balance = balanceSummary.balance - balanceSummary.exposure;
      return {
        ...state,
        balanceSummary: balanceSummary,
      };
    case FETCH_BALANCE_FAILED:
      return {
        ...state,
        balanceSummary: {
          balance: null,
          balanceId: 0,
          currenciesAllowed: 0,
          currency: '',
          exposure: null,
          exposureLimit: 0,
          maxStakeSB: 0,
          minStakeSB: 0,
          preferredCurrency: '',
          username: '',
        },
      };
    case MLOBBY_SHOW:
      return {
        ...state,
        isMolobby: action.payload
      };
    default:
      return state;
  }
};

export default authReducer;
